var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flix-btn flix-btn-xs",class:{'flix-btn-primary' : _vm.active, 'flix-btn-default': !_vm.active},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClick(_vm.id)}}},[_c('flixIcon',{attrs:{"id":'chevron-'+_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }